import {
  GET_CONFIG,
  ON_CONNECT_BUSINESS,
  ON_CONNECT,
  ON_DISCONNECT,
  IS_MOBILE,
  IS_APP_LOADING,
  ON_RESTART_GALLERY,
  ON_CHANGE_VIEW_MODE,
  PREVIEW_HOVER_MODE,
  ON_TEXT_CHANGE,
  ON_ADD_HASHTAG,
  UPDATE_HASHTAG,
  UPDATE_MEDIA_LINKS,
} from '../constants';
import { getAccountData, updateUserLoginData } from './services/dataService';
import { getInstagramData } from './services/instagramService';
import { updateStyle } from './styleParamsActions';
import { reloadAllGallery } from './gallery/galleryHeight';
import { getMediasLinksCount, getLinksSettings } from './services/linksService';
import { getConfigData } from './api/generalApi';
import { addHashtag, getAllHashtagsItems } from './services/hashtagService';
import { isMobile } from './more/utils';
import triggerEvent from './services/biEditorLogger';
import biData from '../bi/editorEvents.json';
import { getLocaleById } from './more/langHelperFunctions';
import store from '../store';
import WixService from './services/WixService';

const compId = WixService.getCompId();

export const loadApp = () => (dispatch) => {
  dispatch({
    type: IS_APP_LOADING,
    payload: true,
  });

  dispatch(getConfig());
  dispatch(setDeviceType());
  dispatch(getAccountData());

  window.Wix.Styles.getStyleParams((style) => dispatch(updateStyle(style)));
  dispatch({
    type: ON_CHANGE_VIEW_MODE,
    payload: window.Wix.Utils.getViewMode(),
  });

  window.Wix.addEventListener(window.Wix.Events.SETTINGS_UPDATED, (data) =>
    dispatch(onSettingsUpdate(data)),
  );

  window.Wix.addEventListener(window.Wix.Events.STYLE_PARAMS_CHANGE, (style) =>
    dispatch(updateStyle(style)),
  );

  window.Wix.addEventListener(window.Wix.Events.EDIT_MODE_CHANGE, (event) => {
    dispatch(onChangeViewMode(event.editMode));
  });
  window.Wix.addEventListener(window.Wix.Events.SITE_PUBLISHED, () => {
    const { user } = store.getState().appReducer;
    const { isBusinessApp } = store.getState().appReducer;
    const { mediasError } = store.getState().appReducer;

    window.Wix.Styles.getStyleParams((style) => {
      const numbersStyle = style.numbers;
      const isSlider = numbersStyle?.layoutType === 2;
      const isSliderHashtag = numbersStyle?.galleryLayoutHashtag === 2;
      const booleansStyle = style.booleans;
      const jsonToPublish = {
        wixlabs_bool_1: user?.ig_id || false,
        wixlabs_bool_2: 1,
        wixlabs_bool_3: booleansStyle.isShowMoreBtn === false ? false : true,
        wixlabs_bool_4: booleansStyle.m_isShowMoreBtn === false ? false : true,
        wixlabs_bool_5: false, // ??
        wixlabs_bool_6:
          booleansStyle.isDisplayProfileInfo === false ? false : true,
        wixlabs_bool_7:
          booleansStyle.isDisplayImagesFeed === false ? false : true,
        wixlabs_bool_8:
          booleansStyle.isDisplayHashtagsFeed === false ? false : true,
        wixlabs_bool_9: booleansStyle.isHoverPost === false ? false : true,
        wixlabs_bool_10: numbersStyle.direction === 1 ? true : false,
        wixlabs_bool_11:
          numbersStyle.profileComponentPosition === 1 ? true : false,
        wixlabs_bool_12: numbersStyle.hashtagLayout === 0 ? false : true,
        wixlabs_bool_13:
          booleansStyle.isShowMoreBtnHashtag === false ? false : true,
        wixlabs_bool_14:
          booleansStyle.m_isShowMoreBtnHashtag === false ? false : true,
        wixlabs_bool_15:
          booleansStyle.e_isStoryAutoplaySoundOn === false ? false : true,
        wixlabs_string_1: buildWixlabsString1(numbersStyle?.layoutType || 1),
        wixlabs_string_2: buildWixlabsString1(
          numbersStyle?.m_galleryLayout || 1,
        ),
        wixlabs_string_3: 1,
        wixlabs_string_4: buildWixlabsString1(
          numbersStyle?.m_galleryLayoutHashtag || 2,
        ),
        wixlabs_string_5: getLocaleById(numbersStyle?.langPicker) || 'en',
        wixlabs_string_6: user?.ig_id
          ? isBusinessApp
            ? 'business'
            : 'personal'
          : 'demo', // account type - business / personal / demo
        wixlabs_string_7: mediasError?.message || null, // error - if the user doesn't have an error then null, if he has an error then the error description
        wixlabs_string_8: user?.ig_id || '', // IG user_id
        wixlabs_string_9: buildWixlabsString9(booleansStyle),
        wixlabs_string_10: buildWixlabsString10(
          numbersStyle?.clickingOnProfilePicture || 1,
        ),
        wixlabs_string_11: buildWixlabsString11(
          numbersStyle?.clickingOnItem || 1,
        ),
        wixlabs_string_12: buildWixlabsString12(
          numbersStyle?.hashtagTitle || 1,
        ),
        wixlabs_string_13: buildWixlabsString13(numbersStyle),
        wixlabs_string_14: buildWixlabsString14(
          numbersStyle?.profilePictureRadius || 50,
        ), // circle / rounded / square
        wixlabs_string_15: buildWixlabsString1(
          numbersStyle?.galleryLayoutHashtag || 2,
        ),
        wixlabs_string_16:
          numbersStyle.displayOnHover === 0 ? 'counters' : 'captions',
        wixlabs_string_17: buildWixlabsString17(booleansStyle),
        wixlabs_num_1: isSlider ? 1 : numbersStyle?.numberOfRowsGrid || 2,
        wixlabs_num_2: isSlider
          ? numbersStyle?.numberOfColumnsSlider || 5
          : numbersStyle?.numberOfColumnsGrid || 3,
        wixlabs_num_3: isSliderHashtag
          ? 1
          : numbersStyle?.numberOfRowsGridHashtag || 2,
        wixlabs_num_4: isSliderHashtag
          ? numbersStyle?.numberOfColumnsSliderHashtag || 5
          : numbersStyle?.numberOfColumnsGrid || 3,
        wixlabs_num_5: 1,
      };
      triggerEvent({ ...biData.SITE_PUBLISHED, ...jsonToPublish });
    });
  });
};

// wixlabs_bool_1 - connected to instagram = true / false
// wixlabs_bool_2 - full width selected = true / false (according to our calculation)
// wixlabs_bool_3 - [Layout] show more (load more) button (posts feed) displayed - desktop = true / false
// wixlabs_bool_4 - [Layout] show more (load more) button (posts feed ) displayed - Mobile = true / false
// wixlabs_bool_5 - [Layout] show more (load more) design = true = button / false = + icon
// wixlabs_bool_6 - [Display] profile info ("your profile") shown = true / false
// wixlabs_bool_7 - [Display] posts feed ("your posts") shown = true / false
// wixlabs_bool_8 - [Display] hashtag feed shown = true / false
// wixlabs_bool_9 - [Settings] enable hover on post - true / false
// wixlabs_bool_10 - [Settings] app direction - true = left to right, false - right to left
// wixlabs_bool_11 - [Layout] your profile layout true = classic, false = center
// wixlabs_bool_12 - [Layout] hashtag feed layout -text alignment true = left, false = center
// wixlabs_bool_13 - [Layout] show more (load more) button (hashtag feed) displayed - desktop = true / false
// wixlabs_bool_14 - [Layout] show more (load more) button (hashtag feed ) displayed - Mobile = true / false
// wixlabs_bool_15 - [Design] expand mode - story - autoplay sound on = true / false
// wixlabs_string_1 - [Layout] selected layout posts feed - desktop = grid / collage / slider
// wixlabs_string_2 - [Layout] selected layout - posts feed - mobile = grid1 / grid2 / grid3 / slider
//  - layout in mobile
// wixlabs_string_4 - show more button - button / icon
// wixlabs_string_5 - [Settings] selected language
// wixlabs_string_6 - account type - business / personal / demo
// wixlabs_string_7 - error - if the user doesn't have an error then null, if he has an error then the error description
// wixlabs_string_8 - IG user_id
// wixlabs_string_9 - [Display] which profile info is shown - string that contains all the parameters that the user chose.
// (username / profile photo and stories / total posts / followers / following / bio / follow button)
// wixlabs_string_10 - [Settings] when clicking on profile photo - show stories / open on instagram / nothing happens
// wixlabs_string_11 - [Settings] when clicking on a post - expand to full screen / open on instagram / nothing happens
// wixlabs_string_12 -[Text]  gallery title on hashtag feed =  show hashtag / costum title / no title
// wixlabs_string_13 - [Layout] layout order - profile-posts-hashtag / profile-hashtag-posts /  hashtag-posts-profile / hashtag-profile-posts / posts-hashtag-profile / posts-profile-hashtag
// wixlabs_string_14 - [Layout] your profile layout - profile photo shape - circle / rounded / square
// wixlabs_string_15 - [Layout] selected layout hashtag feed - desktop = grid / collage / slider
// wixlabs_string_16 -  [Design] posts info - counters / captions
// wixlabs_string_17 - [Design] expand mode - post - what info to display -  string that contains all the parameters that the user chose. captions / comments and replies / counters / timesptamp
// wixlabs_num_1 - [Layout] number of rows posts feed  - Desktop
// wixlabs_num_2 - [Layout] number of columns posts feed  (don't send if layout = slider)
// wixlabs_num_3 - [Layout] number of rows hashtag feed  - Desktop
// wixlabs_num_4 - [Layout] number of columns hashtag feed  (don't send if layout = slider)
// wixlabs_num_5 - [Display] number of hashtags displayed
// event_trigger - [send empty]
const buildWixlabsString1 = (layoutType) => {
  switch (layoutType) {
    case 2:
      return 'slider';
    case 3:
      return 'collage';
    default:
      return 'grid';
  }
};
const buildWixlabsString10 = (clickingOnProfilePicture) => {
  switch (clickingOnProfilePicture) {
    case 2:
      return 'open on instagram';
    case 3:
      return 'nothing happens';
    default:
      return 'show stories';
  }
};
const buildWixlabsString11 = (clickingOnItem) => {
  switch (clickingOnItem) {
    case 2:
      return 'open on instagram';
    case 3:
      return 'nothing happens';
    default:
      return 'expand to full screen';
  }
};
const buildWixlabsString12 = (hashtagTitle) => {
  switch (hashtagTitle) {
    case 2:
      return 'costum title';
    case 3:
      return 'no title';
    default:
      return 'show hashtag';
  }
};
const buildWixlabsString14 = (profilePictureRadius) => {
  switch (profilePictureRadius) {
    case 10:
      return 'rounded';
    case 0.1:
      return 'square';
    default:
      return 'circle';
  }
};
const buildWixlabsString9 = (booleansStyle) => {
  if (booleansStyle.isDisplayProfileInfo === false) {
    return '';
  }
  const isDisplayFollowBtn =
    booleansStyle.isDisplayFollowBtn === false ? false : true;
  const isDisplayFollowersCount =
    booleansStyle.isDisplayFollowersCount === false ? false : true;
  const isDisplayFollowingCount =
    booleansStyle.isDisplayFollowingCount === false ? false : true;
  const isDisplayPostsCount =
    booleansStyle.isDisplayPostsCount === false ? false : true;
  const isDisplayProfileBio =
    booleansStyle.isDisplayProfileBio === false ? false : true;
  const isDisplayProfileInfo =
    booleansStyle.isDisplayProfileInfo === false ? false : true;
  const isDisplayProfilePicture =
    booleansStyle.isDisplayProfilePicture === false ? false : true;

  return `isDisplayFollowBtn=${isDisplayFollowBtn}&isDisplayFollowersCount=${isDisplayFollowersCount}&isDisplayFollowingCount=${isDisplayFollowingCount}&isDisplayPostsCount=${isDisplayPostsCount}&isDisplayProfileBio=${isDisplayProfileBio}&isDisplayProfileInfo=${isDisplayProfileInfo}&isDisplayProfilePicture=${isDisplayProfilePicture}`;
};

const buildWixlabsString17 = (booleansStyle) => {
  const e_isDisplayCaption =
    booleansStyle.e_isDisplayCaption === false ? false : true;
  const e_isDisplayCounters =
    booleansStyle.e_isDisplayCounters === false ? false : true;
  const e_isDisplayComments =
    booleansStyle.e_isDisplayComments === false ? false : true;
  const e_isDisplayTimestamp =
    booleansStyle.e_isDisplayTimestamp === false ? false : true;
  return `e_isDisplayCaption=${e_isDisplayCaption}&e_isDisplayCounters=${e_isDisplayCounters}&e_isDisplayComments=${e_isDisplayComments}&e_isDisplayTimestamp=${e_isDisplayTimestamp}`;
};

const buildWixlabsString13 = (numbersStyle) => {
  const profileComponentPosition = numbersStyle?.profileComponentPosition || 0;
  const feedComponentPosition = numbersStyle?.feedComponentPosition || 1;
  const hashtagComponentPosition = numbersStyle?.hashtagComponentPosition || 2;
  if (
    !profileComponentPosition &&
    profileComponentPosition < feedComponentPosition
  ) {
    if (feedComponentPosition < hashtagComponentPosition) {
      return 'profile-posts-hashtag';
    }
    return 'profile-hashtag-posts';
  }
  if (feedComponentPosition < hashtagComponentPosition) {
    if (hashtagComponentPosition < profileComponentPosition) {
      return 'posts-hashtag-profile';
    }
    return 'posts-profile-hashtag';
  }
  if (profileComponentPosition < feedComponentPosition) {
    return 'hashtag-profile-posts';
  }
  return 'hashtag-posts-profile';
};

const _login = (data, type) => async (dispatch) => {
  data = data.data ? data.data : data;
  dispatch({
    type: IS_APP_LOADING,
    payload: true,
  });
  dispatch(
    updateUserLoginData({
      type,
      accessToken: data.access_token,
      userId: data.user.id,
      expires_in: data.expires_in,
    }),
  );
  await dispatch(getLinksSettings());

  dispatch(getAccountData());
};

export const onSettingsUpdate = (data) => (dispatch) => {
  switch (data.type) {
    case ON_CONNECT_BUSINESS:
      WixService.cleanDataPublicChatch(`settings${compId}`);
      dispatch(_login(data, ON_CONNECT_BUSINESS));
      break;
    case ON_CONNECT:
      WixService.cleanDataPublicChatch(`settings${compId}`);
      dispatch(_login(data, ON_CONNECT));
      break;
    case ON_DISCONNECT:
      dispatch({
        type: IS_APP_LOADING,
        payload: true,
      });
      dispatch({
        type: ON_DISCONNECT,
      });
      WixService.cleanDataPublicChatch(`settings${compId}`);
      dispatch(getInstagramData(true));
      break;
    case PREVIEW_HOVER_MODE:
      const isPreviewMode = data.data.toggled;
      dispatch(chanceHoverMode(isPreviewMode));
      break;
    case ON_TEXT_CHANGE:
      dispatch({
        type: ON_TEXT_CHANGE,
        payload: data.data,
      });
      break;
    case ON_ADD_HASHTAG:
      dispatch(addHashtag(data.data));
      break;
    case UPDATE_HASHTAG:
      dispatch(getAllHashtagsItems(data.data));
      break;
    case UPDATE_MEDIA_LINKS:
      dispatch(getMediasLinksCount());
      break;
    default:
      break;
  }
};

export const onChangeViewMode = (viewMode) => (dispatch) => {
  if (viewMode === 'editor' || viewMode === 'preview') {
    dispatch({
      type: ON_CHANGE_VIEW_MODE,
      payload: viewMode,
    });
    dispatch({
      type: ON_RESTART_GALLERY,
    });
    dispatch(reloadAllGallery());
  }
};

let previewModeTimeout;
const chanceHoverMode = (isPreviewMode) => (dispatch) => {
  dispatch({
    type: PREVIEW_HOVER_MODE,
    payload: isPreviewMode,
  });

  if (previewModeTimeout) {
    clearTimeout(previewModeTimeout);
  }

  if (isPreviewMode) {
    previewModeTimeout = setTimeout(() => {
      dispatch({
        type: PREVIEW_HOVER_MODE,
        payload: false,
      });
    }, 1200);
  }
};

export const setDeviceType = () => (dispatch) => {
  dispatch({
    type: IS_MOBILE,
    payload: isMobile(),
  });
};

export const getConfig = () => (dispatch) => {
  getConfigData()
    .then((config) => {
      dispatch({
        type: GET_CONFIG,
        payload: config,
      });
    })
    .catch((err) => console.log('getConfig err', err));
};
